<template>
  <v-row>
    <v-col>
      <v-stepper v-model="step">
        <v-stepper-header class="bg-blue-300">
          <template v-for="(item, index) in steps">
            <v-stepper-step
              :complete="step > index + 1"
              :key="index"
              :step="index + 1"
            >
              {{ item.name }}
            </v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            v-for="(item, index) in steps"
            :key="index"
            :step="index + 1"
          >
            <keep-alive>
              <component
                :is="item.component"
                :step="index + 1"
                @change-step="changeStep"
              ></component>
            </keep-alive>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script>
import StepOne from "@/components/StepOne.vue";
import StepTwo from "@/components/StepTwo.vue";
import StepThree from "@/components/StepThree.vue";
import StepFour from "@/components/StepFour.vue";

export default {
  name: "Home",

  data() {
    return {
      step: 1,
      steps: [
        {
          name: "Búsqueda",
          component: StepOne,
        },
        {
          name: "Selección",
          component: StepTwo,
        },
        {
          name: "Formulario",
          component: StepThree,
        },
        {
          name: "Resumen",
          component: StepFour,
        },
      ],
    };
  },

  methods: {
    changeStep(i) {
      this.step = i;
    },
  },
};
</script>
